import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Localize } from "components/service";
import { ENABLE_QR_OUTDATED_CHECK } from "../helpers/event-check-qr-policy";


const CheckQrLocationInfo = () => ENABLE_QR_OUTDATED_CHECK ? null : (
    <Tooltip
        title={ <Localize>CHECK_QR.LocationInfo_Hint</Localize> }
        trigger={ [ "hover", "focus" ] }>
        <button
            type="button"
            className="check-qr-location-info"
            aria-label={ Localize({ children: "CHECK_QR.LocationInfo_Label" }).props.children }>
            <InfoCircleOutlined aria-hidden="true" />
        </button>
    </Tooltip>
);

export default CheckQrLocationInfo;
